// @flow
import { gridSize } from '@atlaskit/theme';
import styled, { css } from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const DialogInner = styled.div`
    ${({ isPadded }) =>
        isPadded
            ? css`
                  padding: ${gridSize() * 1.5}px;
              `
            : ''}
    ${({ maxWidth }) =>
        maxWidth
            ? css`
                  max-width: ${maxWidth}px;
              `
            : ''}
    ${({ minWidth }) =>
        minWidth
            ? css`
                  min-width: ${minWidth}px;
              `
            : ''}
`;
DialogInner.defaultProps = {
    isPadded: false,
    maxWidth: 440,
    minWidth: 160,
};
